import React from 'react';
import { toast } from 'sonner';
import { Copy, Music, ChevronRight, RefreshCw, Loader2 } from 'lucide-react';

const Section = ({ label, children, testid, open = false }) => (
  <details open={open} className="group" data-testid={testid}>
    <summary className="cursor-pointer list-none flex items-center gap-1 text-[10px] font-semibold uppercase tracking-[0.08em] text-[#6B6B6B] dark:text-zinc-400 hover:text-[#FF451A] transition-colors">
      <ChevronRight size={11} className="transition-transform group-open:rotate-90" /> {label}
    </summary>
    <div className="mt-1.5 pl-4 text-sm text-[#4B5563] dark:text-zinc-300">{children}</div>
  </details>
);

export const IdeaCard = ({ idea, n, onRegenerate, regenerating }) => {
  const tags = (idea.hashtags || []).join(' ');
  const copy = async () => {
    await navigator.clipboard.writeText(`${idea.hook}\n\n${tags}`);
    toast.success('Hook + hashtags copied');
  };
  return (
    <div className={`relative rounded-xl border border-black/[0.08] dark:border-white/5 bg-white dark:bg-[#0F1115] p-4 space-y-3 flex flex-col transition-opacity ${regenerating ? 'opacity-50' : ''}`} data-testid={`creator-ideation-idea-${n}`}>
      <div className="flex items-start justify-between gap-2">
        <div>
          <div className="text-[10px] font-mono text-[#FF451A]">IDEA {n + 1}{idea.niche ? ` · ${idea.niche.toUpperCase()}` : ''}</div>
          <h3 className="font-bold text-[#0F0F0F] dark:text-white leading-snug" data-testid={`creator-ideation-idea-title-${n}`}>{idea.title || `Idea ${n + 1}`}</h3>
        </div>
        <div className="flex gap-1.5 shrink-0">
        {onRegenerate && (
          <button onClick={onRegenerate} disabled={regenerating} title="Regenerate this idea" className="rounded-full px-2.5 py-1.5 inline-flex items-center gap-1 text-[11px] font-medium border border-black/[0.12] dark:border-white/[0.08] text-[#0F0F0F] dark:text-white hover:border-[#FF451A]/50 hover:text-[#FF451A] disabled:opacity-60 transition-colors" data-testid={`creator-ideation-idea-regen-${n}`}>
            {regenerating ? <Loader2 size={12} className="animate-spin" /> : <RefreshCw size={12} />} Regenerate
          </button>
        )}
        <button onClick={copy} title="Copy hook + hashtags" className="shrink-0 rounded-full p-2 border border-black/[0.12] dark:border-white/[0.08] text-[#0F0F0F] dark:text-white hover:border-[#FF451A]/50 hover:text-[#FF451A] transition-colors" data-testid={`creator-ideation-idea-copy-${n}`}>
          <Copy size={12} />
        </button>
        </div>
      </div>
      <p className="rounded-lg bg-[#FF451A]/[0.08] border-l-4 border-[#FF451A] px-3 py-2.5 text-base font-semibold text-[#0F0F0F] dark:text-white leading-snug select-all" data-testid={`creator-ideation-idea-hook-${n}`}>{idea.hook}</p>
      <div className="space-y-2">
        <Section label="What to shoot" testid={`creator-ideation-idea-shoot-${n}`} open>{idea.shoot || idea.description}</Section>
        {idea.why && <Section label="Why it'll work" testid={`creator-ideation-idea-why-${n}`}>{idea.why}</Section>}
        <Section label="Hashtags" testid={`creator-ideation-idea-tags-${n}`}><span className="text-[#FF451A] text-xs">{tags}</span></Section>
        <Section label="Audio" testid={`creator-ideation-idea-audio-${n}`}><span className="inline-flex items-center gap-1 text-xs"><Music size={11} />{idea.audio}</span></Section>
      </div>
    </div>
  );
};
